/** "01-02-2026 14:30" in the Dutch short format, or "-" when there is no date. */
export const formatDateTime = (date: Date | null | undefined) =>
  date?.toLocaleString("nl", { dateStyle: "short", timeStyle: "short" }) ?? "-";

/** "nog 3 uur", "nog 25 min": how long is left until `expiresAt`. */
export const formatRemaining = (expiresAt: Date) => {
  const minutes = Math.max(1, Math.round((expiresAt.getTime() - Date.now()) / 60000));
  if (minutes < 60) {
    return `nog ${minutes} min`;
  }
  const hours = Math.round(minutes / 60);
  return hours < 48 ? `nog ${hours} uur` : `nog ${Math.round(hours / 24)} dagen`;
};
